export default (category, slug) => `/shop/${category}/${slug}`
